import { privateAPI } from 'services/private';

const patchPasswordRequestsDraft = (draft, passwordRequest, page) => {
  if (!draft?.data?.data) {
    return false;
  }

  const items = draft.data.data;
  const existingIndex = items.findIndex(item => Number(item.id) === Number(passwordRequest.id));

  if (existingIndex >= 0) {
    items.splice(existingIndex, 1);
  } else if (Number(page) === 1) {
    // eslint-disable-next-line no-param-reassign
    draft.data.total = (draft.data.total || 0) + 1;
  }

  if (Number(page) === 1) {
    items.unshift(passwordRequest);
  }

  return Number(page) === 1;
};

export default function upsertPasswordRequestListItem(dispatch, passwordRequest, page = 1) {
  if (!passwordRequest?.id) {
    return false;
  }

  let patched = false;

  try {
    dispatch(
      privateAPI.util.updateQueryData('passwordRequestList', { page: Number(page) || 1 }, draft => {
        if (patchPasswordRequestsDraft(draft, passwordRequest, page)) {
          patched = true;
        }
      })
    );
  } catch {
    // Cache entry may not exist yet.
  }

  if (Number(page) !== 1) {
    try {
      dispatch(
        privateAPI.util.updateQueryData('passwordRequestList', { page: 1 }, draft => {
          if (patchPasswordRequestsDraft(draft, passwordRequest, 1)) {
            patched = true;
          }
        })
      );
    } catch {
      // Cache entry may not exist yet.
    }
  }

  return patched;
}
